/**
 * Licensed Materials - Property of IBM
 * IBM Watson Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import React, { Component } from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import '../stylesheets/FieldItem.scss';
import { classnames as cx, TruncatedText, SVGIcon } from '@ba/ba-ui-carbon-toolkit';
import menuOverflowVertical16 from '@ba/ba-graphics/dist/icons-js/overflow-menu--vertical_32';
import draggable16 from '@ba/ba-graphics/dist/icons-js/draggable_32';
/**
 * The common FieldItem component
 */
export default class FieldItem extends Component {
	static propTypes = {
		className: PropTypes.string,
		fieldName: PropTypes.string.isRequired,
		draggable: PropTypes.bool,
		showActionMenu: PropTypes.bool,
		onOpenActionMenu: PropTypes.func,
		fieldGraphics: PropTypes.node,
		filterInfo: PropTypes.object,
		onMouseEnterCallBack: PropTypes.func,
		onMouseLeaveCallBack: PropTypes.func
	};
	static defaultProps = {
		className: '',
		draggable: true,
		showActionMenu: true,
		onOpenActionMenu: () => {},
		fieldGraphics: null,
		filterInfo: null
	};

	getDOMNode() {
		return this.domNode;
	}

	_renderFilterStringAndNumber(filterInfo) {
		const { filterString, numberOfFilterItems } = filterInfo || {};
		if (filterString) {
			return (
				<div className="bi-common-field-item__infoLine">
					<div className="bi-common-field-item__infoLine__values">
						<TruncatedText value={filterString} />
					</div>
					{numberOfFilterItems ? (
						<div className="bi-common-field-item__infoLine__badge">
							{numberOfFilterItems}
						</div>
					) : null}
				</div>
			);
		}

		return null;
	}

	render() {
		const {
			fieldName,
			className,
			draggable,
			showActionMenu,
			onOpenActionMenu,
			fieldGraphics,
			filterInfo
		} = this.props;
		const forwardedProps = _.omit(
			this.props,
			'className',
			'children',
			'fieldName',
			'draggable',
			'showActionMenu',
			'onOpenActionMenu',
			'fieldGraphics',
			'filterInfo'
		);
		const hasFilters = !!(filterInfo && filterInfo.filterString);
		const classNames = cx('bi-common-field-item', {
			'has-filters': hasFilters,
			'is-draggable': draggable
		});

		return (
			<div
				className={className ? `${classNames} ${className}` : classNames}
				aria-label={fieldName}
				tabIndex="0"
				ref={node => {
					this.domNode = node;
				}}
				{...forwardedProps}
			>
				<div className="bi-common-field-item__nameLine"
					onMouseEnter = {this.props.onMouseEnterCallBack}
					onMouseLeave = {this.props.onMouseLeaveCallBack}>
					{draggable && (
						<div className="bi-common-field-item__nameLine__draggable">
							<SVGIcon size="small" iconId={draggable16.id} />
						</div>
					)}
					<div className="bi-common-field-item__nameLine__fieldName">
						{hasFilters ?
							<div><TruncatedText location="middle" style={{ fontWeight: 'bold' }} value={fieldName} /></div> :
							<TruncatedText location="middle" style={{ fontWeight: 'normal' }} value={fieldName} />
						}
					</div>
					{fieldGraphics && (
						<div className="bi-common-field-item__nameLine__icon">
							<span dangerouslySetInnerHTML={{ __html: fieldGraphics }} />
						</div>
					)}
					{showActionMenu && (
						<div
							className="bi-common-field-item__nameLine__actionMenu"
							tabIndex={0}
							onKeyPress={(e) => {
								e.stopPropagation();
								onOpenActionMenu(e);
							}}
							onClick={(e) => {
								e.stopPropagation();
								onOpenActionMenu(e);
							}}
						>
							<SVGIcon size="small" iconId={menuOverflowVertical16.id} />
							<div className="actionmenu" />
						</div>
					)}
				</div>
				{this._renderFilterStringAndNumber(filterInfo)}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/js/FieldItem.js